document.addEventListener('DOMContentLoaded', () => {
    /*
    * Switching to the "Account Details" modal window from the "Email Confirmed" window
    */
    const continueButtonToAccountDetails = document.getElementById('wcl-js-continue');

    if (continueButtonToAccountDetails) {
        const modalConfirmation = continueButtonToAccountDetails.closest('.wcl-modal-layout');
        const modalAccountDetails = document.getElementById('wcl-accound-details-popup');

        continueButtonToAccountDetails.addEventListener('click', function () {
            modalConfirmation.classList.remove('active');
            modalAccountDetails.classList.add('active');
        });
    }

    /*
    * Show and hide password
    */
    const passwordInputList = document.querySelectorAll('.wcl-modal-form .wcl-modal-form-password');

    if (passwordInputList.length > 0) {
        passwordInputList.forEach(item => {
            const input = item.querySelector('input');
            const showButton = item.querySelector('.wcl-show-password-button');

            showButton.addEventListener('click', e => {
                e.preventDefault();

                if (input.type == 'password') {
                    input.type = 'text';
                    showButton.classList.add('hide')
                } else {
                    input.type = 'password';
                    showButton.classList.remove('hide')
                }
            });
        });
    }
});